import React from 'react';
import { NodeProps, useEdges, useNodes, useReactFlow } from 'reactflow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { updateNodeValue } from '../../../../../services/method';
import { operationType } from '../../../../../services/types';
import { Main, Styled } from './style';
import { Switch } from '../../../../form/switch';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { ExpandedBlock } from '../../../expanded';

type FlowQueueProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function FlowQueue({ id, data, setChildMinimize, setChildSettings }: FlowQueueProps) {
   const nodes = useNodes();
   const edges = useEdges();
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      if (!data.value) {
         updateNodeValue(id, setNodes, { isUnique: true })
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // --- 
   const filter = nodes.filter(node => edges.some(edge => edge.target === id && node.id === edge.source));
   const isWarning = !filter.length;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         {isWarning ? <>
                <div id="warning"></div>
                <span id="warningIcon"><IoWarningOutline size={21} /></span>
            </> : data.output ? <>
                <div id="ran"></div>
                <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
            </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '360px' }}
         ><Styled>
            <div className="flex">
               <div className="status memory">Memory ({ data.value?.memory?.length || 0 })</div>
               <div className="status remove" onClick={ _=> updateNodeValue(id, setNodes, { memory: []}) }><FontAwesomeIcon icon={ faTrashCan } /></div>
            </div>
            <div className="status">
               { filter.length ? filter.map(item => (
                  <div key={ item.id }>
                     <span></span>
                     <span>{ // @ts-ignore
                        item.data?.index 
                     }</span> 
                  </div>
               )) : <span className="empty">No blocks connected</span> }
            </div>
            <Switch title="Only unique value" className="unique" value={ !!data.value?.isUnique } setValue={ () => updateNodeValue(id, setNodes, { isUnique: !data.value?.isUnique }) } />
            <Switch title="Run workflow auto" className="auto" value={ !!data.value?.isAuto } setValue={ () => updateNodeValue(id, setNodes, { isAuto: !data.value?.isAuto }) } />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}